import { render, staticRenderFns } from "./faults.vue?vue&type=template&id=32522f0f&scoped=true&"
import script from "./faults.vue?vue&type=script&lang=js&"
export * from "./faults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32522f0f",
  null
  
)

export default component.exports